import React from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { logoutUser } from "../../../actions/authActions";
import { withRouter } from "../../../utils/utility";
import { USER_TYPES } from "../../../routes/types/private";
import AdminNavbar from "./admin/navbar";
import SuperAdminNavbar from "./super-admin/navbar";
import StaffNavbar from "./staff/navbar";
import { getImpersonatorSession, exitImpersonation } from "../../../utils/impersonation";
//import CustomerNav from "./CustomerNav";
const Navbar = (props) => {
  const dispatch = useDispatch();

  /**
   * logout current logged in user.
   * If an impersonation session is active, exit it cleanly instead of
   * fully logging out (which would destroy the super-admin's saved session).
   * @returns void
   */
  const onLogout = () => {
    if (getImpersonatorSession()) {
      exitImpersonation(dispatch, props.router?.navigate);
    } else {
      props.logoutUser();
    }
  };

  if (localStorage.userType) {
    switch (localStorage.userType) {
      case USER_TYPES.admin:
        return <AdminNavbar userLogout={onLogout} />;
      case USER_TYPES.superAdmin:
        return <SuperAdminNavbar userLogout={onLogout} />;
      case USER_TYPES.staff:
        return <StaffNavbar userLogout={onLogout} />;
      //case USER_TYPES.customer:
      //  return <CustomerNav userLogout={onLogout} />;
      default:
        return null;
    }
  }
};

Navbar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(withRouter(Navbar));
